import { AttentionTypes } from '../../Definitions'
import { Pages } from '../../Navigation/root'
import { LangFile } from '.'

const Texts: LangFile = {
  // #region | General
  additional: "additional",
  and: "en",
  change: "wijzigen",
  choose: "kies",
  deleteFailed: "delete failed", //NEW 03-03-2026
  editFailed: "edit failed", //NEW 03-03-2026
  filterBy: "filter op",
  from: "van",
  general: "algemeen", //NEW 17-11-2025
  no: "nee",
  noData: "Geen gegevens",
  noOptions: "Geen opties",
  of: "van",
  off: "uit",
  on: "aan",
  optional: "optioneel",
  page: "pagina",
  reset: "resetten",
  required: "vereist",
  saveAlert: "Sla op of annuleer de bewerkingsweergave.",
  search: "Zoeken",
  select: "Selecteren",
  success: "Succes",
  to: "naar",
  unknown: "unknown",
  wasUpdated: "was updated", //NEW 05-03-2026
  wasDeleted: "was deleted", //NEW 05-03-2026
  useSelectedTime: "gebruik geselecteerde tijd",
  yes: "ja",
  // #endregion

  // Regarding the language list:
  // Please translate only your own language. 
  // If your language is not on the list, then add it using a maximum of two 
  // initials followed by a colon and the language in quotation marks.
  languages: { 
    en: "english",
    dk: "dansk",
    es: "español",
    de: "deutsch",
    ma: "mandarin",
    ko: "한국어",
    nl: "nederlands",
  },

  cookie: {
    header: "Cookies",
    context1: "Agrisys A/S gebruikt cookies voor de volgende doeleinden:",
    context2: "Door op “Alles accepteren” te drukken accepteert u ons gebruik van cookies. Anders wordt een minimum aan cookies gebruikt dat nodig is om de dienst te laten functioneren, bijvoorbeeld voor het beheren van inloggen en het ophalen van gegevens van het Consys-platform.",
    purpose1: "Om de functionaliteit van de website te ondersteunen, bijvoorbeeld door uw instellingen met betrekking tot cookies, voorkeurstalen, valuta’s, enz. te onthouden.",
    purpose2: "Voor statistische analyse van uw gebruik van de website, bijvoorbeeld door te meten welk type inhoud u bekijkt en waarop u klikt.",
    accept: "Noodzakelijke accepteren",
    acceptAll: "Alles accepteren"
  },

  // #region | Units
  units: {
    animal: "dier",
    animals: "dieren",
    units: "eenheden",
    capacity: "capaciteit",
    day: "dag",
    days: "dagen",
    g: "g",
    hour: "uur",
    hourAgo: "uur geleden",
    hours: "uren",
    hoursAgo: "uren geleden",
    kg: "kg",
    minutAgo: "minuut geleden",
    minutesAgo: "minuten geleden",
    min: "min",
    pct: "pct",
    sec: "sec", // NEW 04-12-2025
    time: "tijd",
    times: "keer",
    timeToday: "tijd vandaag",
    timesToday: "keer vandaag",
    total: "totaal",
    energy: "energie",
    gramPerMinute: "gram per minuut",
    lenght: "lengte"
  },
  // #endregion

  // #region | Buttons
  buttons: {
    add: "toevoegen",
    apply: "toepassen",
    cancel: "annuleren",
    commit: "doorvoeren",
    confirm: "bevestigen",
    create: "maken",
    csv: "csv",
    deselectAll: "alles deselecteren",
    details: "details",
    edit: "bewerken",
    excel: "excel",
    filter: "filter",
    goBack: "terug",
    menu: "menu",
    move: "verplaatsen",
    next: "volgende",
    options: "opties",
    prev: "vorige",
    print: "afdrukken",
    resetFilters: "filters resetten",
    save: "opslaan",
    selectAll: "alles selecteren"
  },
  // #endregion

  // #region | Menu Headers
  menuHeaders: {
    overview: "overzicht",
    globalMenu: "globaal menu",
    systemMenu: "systeemmenu",
    attentions: "meldingen",
    quickEntry: "snelle invoer",
    language: "taal",
    [Pages.dashboard]: "dashboard",
    [Pages.kpi]: "kpi",
    [Pages.feedCurves]: "voercurves",
    [Pages.components]: "componenten",
    [Pages.componentsAlternatives]: "componentalternatieven",
    [Pages.mixtures]: "mengsels",
    [Pages.silos]: "silo's",
    [Pages.silosSettings]: "silo-instellingen",
    [Pages.animals]: "dieren",
    [Pages.animalsGroups]: "diergroepen",
    [Pages.reports]: "rapporten",
    [Pages.archive]: "archief",
    [Pages.logbook]: "logboek",
    [Pages.globalSettings]: "instellingen",
    [Pages.devices]: "apparaten",
    [Pages.freeda_lf]: "overzicht",
    [Pages.freeda_lf_sections]: "secties",
    [Pages.freeda_lf_settings]: "instellingen",
    [Pages.op_operations]: "bewerkingen",
    [Pages.op_quickEntry]: "Snelle invoer",
    [Pages.freeda_esf]: "overzicht",
    [Pages.freeda_esf_sections]: "secties",
    [Pages.freeda_esf_settings]: "instellingen"
  },
  // #endregion

  // #region | User
  user: {
    userInformation: "gebruikersinformatie",
    user: "gebruiker",
    userName: "Gebruikersnaam",
    firstName: "Voornaam",
    lastName: "Achternaam",
    phone: "Telefoon",
    email: "E-mail",
    password: "Wachtwoord",
    repeatPassword: "Herhaal wachtwoord",
    country: "Land",
    address: "Adres"
  },
  // #endregion

  // #region | Farm
  farm: {
    farmInformation: "bedrijfsinformatie",
    farmName: "bedrijfsnaam",
    city: "plaats",
    street: "straat",
    phone: "telefoon",
    vat: "btw",
    email: "e-mail"
  },
  // #endregion

  // #region | Milestones
  milestones: {
    general: {
      milestone: "mijlpaal",
      milestones: "mijlpalen",
      noMilestoneFound: "geen mijlpaal gevonden",
      animalsInMilestones: "dieren in mijlpalen",
      latestMilestone: "huidige mijlpaal",
      milestoneDay: "huidige mijlpaaldag",
      newMilestone: "Nieuwe mijlpaal"
    },
    defaultMilestones: {
      farrowing: "Werpen",
      insemination: "Inseminatie",
      weaning: "Spenen",
      movedToFarrowing: "Verplaatst naar kraamstal"
    }
  },
  // #endregion

  // #region | Events
  events: { 
    events: "events", 
    eventType: "type", 
    eventDate: "date", 
    eventNote: "note", 
    eventTime: "time", 
    typeMissing: "type missing", 
    dateMissing: "date missing", 
    noteMissing: "note missing", 
    addEvent: "add event",
    animal: "animal",
  },
  // #endregion

  // #region | Devices
  devices: {
    devices: "apparaten",
    name: "naam",
    cpuId: "cpu-id",
    type: "Type",
    connection: "verbinding",
    system: "systeem",
    noControllersFound: "geen lan-controllers gevonden",
    lanControllers: "lan-controllers",
    newLcBoard: "nieuwe lc-kaart",
    boardName: "kaartnaam",
    noIoBoards: "geen i/o-kaarten gevonden",
    ioBoards: "i/o-kaarten",
    newIoBoard: "nieuwe i/o-kaart",
    layout: "lay-out",
    horizontal: "Horizontaal",
    vertical: "Verticaal",
    asc: "Oplopend",
    desc: "Aflopend",
    columns: "kolommen",
    rows: "rijen",
    order: "volgorde",
    direction: "richting",
    chooseIo: "kies i/o",
    remainingInputs: "overige ingangen",
    remainingOutputs: "overige uitgangen",
    aicoIo: "I/O-kaart",
    output: "Uitgang",
    input: "Ingang",
    board: "kaart",
    moveBoard: "kaart verplaatsen",
    noTerminals: "Geen terminals",
    terminalPort: "Terminalpoort",
    pen: "Hok",
    ioSpecifications: "i/o-specificaties",
    numbering: "nummering",
    manual: "handmatig",
    automatic: "automatisch",
    pattern: "patroon",
    topLeft: "linksboven",
    topRight: "rechtsboven",
    bottomLeft: "linksonder",
    bottomRight: "rechtsonder",
    startCorner: "starthoek",
    noLanController: "Geen lan-controller",
    noCpuId: "Geen cpu-id",
    noSystem: "Geen systeem",
  },
  // #endregion

  // #region | System Controls
  systemControls: {
    general: {
      startSystem: "systeem starten",
      systemControls: "systeembediening",
      emergencyStop: "noodstop",
      stopSystem: "systeem stoppen",
      startAll: "alles starten",
      startSection: "sectie starten",
      startSelected: "geselecteerde starten",
      calibrateSection: "sectie kalibreren",
      calibrateSelected: "geselecteerde kalibreren",
      emptySection: "sectie legen",
      emptySelected: "geselecteerde legen",
      clickPen: "Klik op elk hok dat u wilt selecteren",
      unClickPen: "Klik op elk hok dat u wilt deselecteren",
      orSelectAll: "Of selecteer alles",
      orDeselectAlle: "Of deselecteer alles",
      problem: "probleem",
      problems: "problemen",
      warning: "waarschuwing",
      warnings: "waarschuwingen",
      attention: "melding",
      attentions: "meldingen",
      attentionType: "Type melding",
      systemState: "Systeemstatus",
      staticFeeding: "Statisch voeren",
      nextFeeding: "Volgende voerbeurt",
      resolvedWeight: "vastgesteld gewicht",
      noPensSelected: "Geen hokken geselecteerd",
      feeding: "Voeren",
      feedingFailed: "Voeren mislukt",
      calibrating: "Kalibreren",
      calibratingFailed: "Kalibreren mislukt",
      changeTime: "Tijd wijzigen",
      emptyingFor: "Legen gedurende",
      emptyingFailed: "Legen mislukt",
      confirmStop: "Wilt u de noodstop van het systeem uitvoeren?",
      goToSystem: "ga naar systeem",
      systemStatus: "systeemstatus",
      date: "datum",
      level: "niveau",
      type: "type",
      inspect: "inspecteren",
      delete: "verwijderen",
      logid: "log-id",
      system: "Systeem",
      motor: "Motor",
      animal: "Dier",
      alerts: "meldingen",
      location_name: "Locatienaam",
      fk_lan_controllers: "FK Lan-controllers",
      lan_controller_log_id: "Lan-controller log-ID",
      attention_message: "Meldingsbericht",
      attention_time: "Meldingstijd",
      runningWith: "draait met",
      technicalData: "Technische gegevens",
    },
    states: {
      [AttentionTypes.good]: "Actief",
      [AttentionTypes.neutral]: "Uit",
      [AttentionTypes.warning]: "Waarschuwing",
      [AttentionTypes.alert]: "Alarm"
    },
    createSystem: {
    },
    blueprint: {
    }
  },
  // #endregion

  // #region | Motor Specs //NEW 04-12-2025
  motorSpecs: {
    general: {
      skipCnt: "aantal overslaan",
      skipTime: "tijd overslaan",
      powerConsumption: "stroomverbruik",
      calibrationValue: "kalibratiewaarde",
      rotationTime: "rotatietijd",
      statusMode: "statusmodus",
      noSkip: "Niet overgelagen",
      noPowerConsumption: "Geen stroomverbruik",
      noCalibrationValue: "Geen kalibratiewaarde",
      noRotationTime: "Geen rotatietijd",
      noStatusMode: "Geen statusmodus",
      pending: "in behandeling",
      activated: "geactiveerd",
      skippedUntil: "Overslaan tot",
      noLiveData: "Geen live gegevens"
    },
    terminalTypes: {
      defaultMotor: "standaardmotor",
      locationFeeder: "lf-motor",
      activator: "activator",
      water: "water"
    },
    terminalProgrammed: {
      disabled: "Uitgeschakeld",
      calibration: "Kalibratie",
      feedingOnFeedingTimes: "Voeren op voertijden",
      motorPassive: "Motor passief"
    }
  },
  // #endregion

  // #region | Params
  params: {
    animal: "Dier",
    animalId: "Diernr.",
    location: "Locatie",
    feedCurve: "Voercurve",
    group: "Groep",
    condition: "Conditie",
    removeAnimals: "Dieren verplaatsen",
    resetTotalConsumed: "Totaal verbruikt resetten",
    manualFeedStart: "Handmatig voeren starten",
    clearCalendarEvents: "Kalender-evenementen legen",
    insemination: "Inseminatie",
    weaning: "Spenen",
    farrowing: "Werpen",
    pregnancyCheck: "Drachtcontrole",
    birthDate: "Geboortedatum",
    pregnant: "Dragend",
    responderNo: "Respondernr.",
    lifeNo: "Levensnr.",
    animalType: "Diertype",
    milestone: "Mijlpaal",
    system: "Systeem",
    excess_remaining: "Meer tekort dan",
  },
  negativeParams: {
    animal: "Geen dier",
    animals: "Geen dieren",
    animalId: "Geen diernr.",
    location: "Geen locatie",
    feedCurve: "Geen voercurve",
    group: "Geen groep",
    condition: "Geen conditie",
    birthDate: "Geen geboortedatum",
    pregnant: "Niet dragend",
    responderNo: "Geen respondernr.",
    lifeNo: "Geen levensnr.",
    animalType: "Geen diertype",
    milestone: "Geen mijlpaal",
    system: "Geen systeem",
    ds: "Geen DS",
    energy: "Geen energie",
    limit: "Geen limiet",
    gramPerMinute: "Geen gram per minuut",
    priority: "Geen prioriteit",
    protein: "Geen eiwit",
  },
  // #endregion

  configs: {},

  // #region | Feed
  feed: {
    general: {
      feed: "voer",
      feeding: "voeren",
      remainingToday: "Resterend vandaag",
      remainingYesterday: "Resterend gisteren",
      waterUseToday: "Watergebruik vandaag",
      notFed: "minder dan 20% gevoerd laatste twee dagen",
      feedLastDays: "laatste 10 dagen",
      currentProgress: "huidige voortgang",
      fedLastPeriod: "gevoerd in laatste periode",
      fedTotal: "totaal gevoerd",
      feedConsumption: "voeropname",
      feedBalance: "voerbalans",
      consumedToday: "vandaag verbruikt",
      consumedYesterday: "gisteren verbruikt"
    },
    feedCurve: {
      feedCurve: "Voercurve",
      active: "actief",
      noFeedCurve: "Geen voercurve gevonden",
      default: "standaard",
      minFeedSpeed: "minimale voersnelheid (g/min)",
      maxFeedSpeed: "maximale voersnelheid (g/min)",
      feedSpeed: "voersnelheid",
    },
    feedCorrection: {
      increased: "verhoogd",
      decreased: "verlaagd",
      disabled: "uitgeschakeld",
      feedCorrection: "Voercorrectie",
      feedCorrections: "Voercorrecties",
    },
    feedSkip: {
      feedSkip: "voer overslaan",
      skipFeeding: "voeren overslaan",
      noSkip: "geen voerbeurten overgeslagen",
      skipForNow: "voor nu",
      plan: "plannen",
      planFeedSkip: "voerbeurt overslaan plannen",
      standardSkip: "standaard",
      startFeeding: "voeren starten",
      invalidDay: "ongeldige dag",
      invalidTime: "ongeldige tijd",
      endDateBeforeStartDate: "einddatum ligt vóór startdatum",
      endTimeBeforeStartTime: "eindtijd ligt vóór starttijd",
      timeSpan: "tijdsduur",
      timeAmount: "tijdhoeveelheid",
      startDate: "startdatum",
      endDate: "einddatum",
      startTime: "starttijd",
      endTime: "eindtijd",
      plannedSkip: "geplande overslag",
      recentFeedSkipSuccess: "Recente status van geslaagde overgeslaagde voerbeurten",
    }
  },
  // #endregion

  // #region | Login Flow
  loginFlow: {
    def: {
      fullView: "Desktop weergave",
      focus_view: "Telefoonweergave",
      goToSiteList: "Ga naar sitelijst",
      switchTofocus_view: "Schakelen naar telefoonweergave",
      switchToFullView: "Schakelen naar Desktop weergave"
    },
    login: {
      login: "inloggen",
      logOut: "Uitloggen",
      welcomeBack: "welkom terug",
      notRegisteredYet: "Nog niet geregistreerd",
      createNewuser: "nieuwe gebruiker maken",
      forgotPassword: "Wachtwoord vergeten",
      resetPassword: "wachtwoord opnieuw instellen",
      missingUserName: "gebruikersnaam ontbreekt",
      missingPassword: "wachtwoord ontbreekt",
      couldNotLogin: "inloggen mislukt",
      noSitesFound: "geen sites gevonden"
    },
    forgotPassword: {
      forgotPassword: "wachtwoord vergeten",
      resetPassword: "wachtwoord opnieuw instellen",
      text: "Als er geen e-mail aan de gebruikersnaam is gekoppeld, neem dan contact op met de support voor verdere hulp.",
      text2: "Sluit dit venster niet voordat het resetproces is voltooid.",
      noEmail: "Geen e-mail gekoppeld",
      contactSupport: "contacteer support",
      usernameRequired: "gebruikersnaam vereist",
      noUsernameFound: "gebruikersnaam bestaat niet"
    },
    resetPassword: {
      resetPassword: "wachtwoord opnieuw instellen",
      text: `Er is een tijdelijke code naar uw e-mail gestuurd. Vul die hieronder in om een nieuw wachtwoord aan te maken.`,
      temporaryCode: "Tijdelijke code",
      newPassword: "Nieuw wachtwoord",
      repeatPassword: "Herhaal nieuw wachtwoord",
      createNewPassword: "nieuw wachtwoord aanmaken",
      contactSupport: "contacteer support",
      noPasswordRevieved: "Geen tijdelijke code ontvangen",
      newPasswordFail: "aanmaken nieuw wachtwoord mislukt"
    },
    createUser: {
      newUser: "nieuwe gebruiker",
      missingUserName: "gebruikersnaam ontbreekt",
      missingPassword: "wachtwoord ontbreekt",
      missingRepeatPassword: "herhaal wachtwoord",
      passwordMismatch: "wachtwoorden komen niet overeen",
      success: "succes"
    },
    chooseSite: {
      chooseSite: "site kiezen",
      siteName: "sitenaam",
      domain: "domein",
      id: "id",
      tools: "tools"
    }
  },
  // #endregion

  // #region | Widgets
  widgets: {
    general: {
      noWidgets: "Er zijn momenteel geen widgets op deze pagina.",
      widgetOptions: "widgetopties",
      manageWidgets: "beheren",
      name: "Naam",
      type: "Type",
      widgetPriority: "Prioriteit",
      createNew: "nieuw maken",
      copyExisting: "bestaande kopiëren",
    },
    widgetTypes: {
      autoReports: "Automatische rapporten",
      autoReportsAndMore: "Automatische rapporten enz.",
      graph: "Grafiek",
      progress: "Voortgangscirkels",
    },
    graph: {
      noGraphSelected: "Geen grafiek geselecteerd",
      graphIncludesStart: "De grafiek omvat alle dieren",
      graphIncludesEnd: "die voerconsumptiedata hebben",
      animalsToInclude: "Dieren om op te nemen op basis van systeem",
      last10DaysConsumption: "Voeropname laatste 10 dagen"
    },
    autoReports: {
      autoReports: "Automatische rapporten",
      navigatedFromSystem: "Genavigeerd vanuit systeem",
      add: "Automatisch rapport toevoegen",
      addExisting: "bestaande toevoegen"
    }
  },
  // #endregion

  // #region | Penlist
  penList: {
    basicDisclaimer: "Houd de muis op een waarde om het kolomtype te zien",
    editDisclaimer: "Bewerk een dier door nieuwe waarden te selecteren",
    addDisclaimer: "Voeg een dier toe uit de keuzelijst of verwijder het weer via het prullenbakpictogram",
    moveDisclaimer: "Verplaats een dier naar een nieuwe locatie via de keuzelijst of verwijder het van een locatie via het prullenbakpictogram",
  },
  // #endregion

  // #region | Feed Curve pages
  feedCurvePages: {
    feedCurves: {
      copyFeedCurve: "voercurve kopiëren",
      createFeedCurve: "voercurve maken",
      createFeedCurveFromScratch: "Voercurve vanaf nul maken",
      feedCurveDetails: "details voercurve",
      newFeedCurve: "nieuwe voercurve",
      feedCurveName: "naam voercurve",
      fromFeedCurve: "van voercurve",
      feedCurveNameMissing: "naam voercurve ontbreekt",
      goToFeedCurvePage: "ga naar voercurve-pagina" // NEW 11-11-2025
    },
    components: {
      components: "componenten",
      emptyText: "geen componenten gevonden",
      name: "Naam component",
      readyMixture: "Gereed voor gebruik",
      priority: "Prioriteit",
      ds: "DS",
      energy: "Energie",
      protein: "Eiwit",
      gramPerMinute: "Gram per minuut",
      limit: "Limiet",
    },
    feedCurve: {
      spreading: "spreiding",
      spreadings: "Spreidingen",
      noSpreading: "Geen spreiding",
      settings: "instellingen",
      day: "dag",
      watchFeedCurve: "voercurve bekijken",
      doNotPassFeed: "Geen voer doorgeven",
      passFeed: "Voer doorgeven",
      stimuli: "Stimuli",
      noStimuli: "Geen stimuli",
      addStimuli: "Stimuli toevoegen",
      singleStimuli: "Enkele stimulus",
      repeatStimuli: "Stimulus herhalen",
      maxAmount: "max. periodehoeveelheid (kg)",
      remainingFeed: "resterend voer",
      maxFeedToPass: "max. kg om door te geven",
      max: "max",
      feeding: "voeren",
      feedings: "voederbeurten",
      feedStimuli: "voerstimulus",
      minutesApart: "minuten uit elkaar",
      addTime: "tijd toevoegen",
      saveChanges: "wijzigingen opslaan",
      resetChanges: "wijzigingen resetten",
      feedCurveLenght: "Lengte",
      feedLimit: "Voerlimiet",
      animalCount: "Dieren",
      consumedToday: "Vandaag verbruikt",
      usage: "huidig gebruik", // NEW 11-11-2025
      unknownMilestoneAndDay: "Onbekende mijlpaal en dag", // NEW 19-11-2025
      deleteFeedcurve: "voercurve verwijderen", // NEW 01-12-2025
      confirmDelete: "Weet u zeker dat u deze voercurve wilt verwijderen?" // NEW 01-12-2025
    }
  },
  // #endregion

  // #region | Animal pages
  animalPages: {
    animals: {
      animals: "dieren",
      emptyText: "Geen dieren gevonden",
      quickEntry: "snelle invoer",
      newAnimal: "nieuw dier",
      viewChanges: "wijzigingen bekijken",
      action: "actie",
      selectAnimals: "dieren selecteren",
      missingAnimalNo: "diernr. ontbreekt",
      missingResponderNo: "respondernr. ontbreekt",
      kgFedMore: "KG meer gevoerd dan verwacht",
      noAnimalsMatchTheSelection: "Geen dieren komen overeen met de selectie"
    },
    animalGroups: {
      group: "groep",
      numberOfAnimals: "Aantal dieren",
      createGroup: "groep maken",
      newGroup: "nieuwe groep",
      groupName: "groepsnaam",
    },
    animal: {
      animal: "dier",
      basicInfo: "basisgegevens",
      noAnimalSelected: "geen dier geselecteerd",
      noAnimalsSelected: "geen dieren geselecteerd",
      addAnimal: "dier toevoegen",
      addAnimalToPen: "dier toevoegen aan hok",
      pen: "Hok",
      moveAnimal: "dier verplaatsen",
      moveAnimals: "dieren verplaatsen",
      moveAnimalFromPen: "dier naar hok verplaatsen",
      goToAnimal: "ga naar dierpagina",
      totalCycleDay: "totale cyclusdag",
      marking: "markering",
      events: "gebeurtenissen",
      eventName: "Naam",
      eventDate: "Datum",
      eventNote: "Notitie",
      noTimeline: "geen tijdlijn",
      addEvent: "gebeurtenis toevoegen",
      timeline: "tijdlijn",
      viewTimeline: "tijdlijn bekijken",
      born: "geboren",
      timelineShows: "tijdlijn toont pariteit",
      parity: "pariteit",
      deleteAnimal: "dier verwijderen", // NEW 27-11-2025
      deleteConfirm: "Weet u zeker dat u dit dier wilt verwijderen?" // NEW 27-11-2025
    }
  },
  // #endregion

  // #region | Report pages
  reportPages: {
    reports: {
      template: "Sjabloon",
      templateName: "Sjabloonnaam",
      addTemplate: "sjabloon toevoegen",
      copyTemplate: "sjabloon kopiëren",
      createReport: "rapport maken",
      createNewReport: "Een nieuw rapport vanaf nul starten",
      newTemplate: "nieuw sjabloon",
      newReport: "nieuw rapport",
      dataLevel: "Dataniveau",
      filterParameter: "Filterparameter",
      dataParameter: "dataparameter",
      reportName: "rapportnaam",
      archiveReport: "rapport archiveren",
      startDate: "startdatum",
      endDate: "einddatum",
      showInReport: "Toon in rapport",
      fromTemplate: "van sjabloon",
      noReportFound: "geen rapport gevonden",
      noDataParameterFound: "geen dataparameter gevonden",
      unknownCondition: "onbekende conditie",
      unknownAnimalGroup: "onbekende groep",
      noFilterParameterFound: "geen filterparameters gevonden",
      saveAsTemplate: "opslaan als sjabloon",
    },
    manageTemplates: { // NEW 28-11-2025
      templateOptions: "sjabloonopties", // NEW 28-11-2025
      manageTemplates: "beheren", // NEW 28-11-2025
      copyExisting: "bestaande kopiëren", // NEW 28-11-2025
      noTemplates: "Er zijn momenteel geen sjablonen op deze pagina.",
    }, // NEW 28-11-2025
    report: {
      report: "rapport",
      editReport: "rapport bewerken",
      unArchiveReport: "rapport uit archief halen",
      saveAsTemplate: "opslaan als sjabloon",
      noReport: "geen rapport gevonden",
      noReports: "U heeft geen gearchiveerde rapporten", // NEW 26-11-2025
      deleteReport: "rapport verwijderen", // NEW 27-11-2025
      deleteConfirm: "Weet u zeker dat u dit rapport wilt verwijderen?" // NEW 27-11-2025
    },
    reportColumn: {
      system: "Systeem",
      system_id: "Systeem",
      animal_id: "Dier",
      location: "Locatie",
      location_id: "Locatie",
      section_id: "Sectie",
      section: "Sectie",
      feedcurve_id: "Voercurve",
      feedCurveId: "Voercurve",
      animal_number: "Diernr.",
      cycle: "Cyclus",
      correction: "Correctie",
      feedcurve_milestones: "Voercurve mijlpalen",
      milestone_day: "Mijlpaaldag",
      condition: "Conditie",
      animal_type: "Diertype",
      responder_number: "Respondernr.",
      life_number: "Levensnr.",
      birthday: "Geboortedatum",
      animal_group_name: "Groep",
      milestone_name: "Mijlpaal",
      milestone_id: "Mijlpaal",
      animal_group_id: "Groep",
      group_id: "Groep",
      group_name: "Groep",
      system_id_for_report: "Systeem-id voor rapporten",
      system_name: "Systeem",
      totalPeriodConsumption: "Totale consumptie periode",
      consumed: "Verbruikt"
    },
    archive: {
      archive: "archief",
      filterByNumber: "rapportnummer",
      filterByName: "rapportnaam alfabetisch",
      archivedReport: "Gearchiveerd rapport",
      noStartDateFound: "Geen startdatum gevonden",
      noEndDateFound: "Geen einddatum gevonden",
    },
    errorMessages: { // NEW 28-11-2025
      missingName: "naam ontbreekt", // NEW 28-11-2025
      missingStartDate: "startdatum ontbreekt", // NEW 28-11-2025
      missingEndDate: "einddatum ontbreekt", // NEW 28-11-2025
      missingDataLevel: "dataniveau ontbreekt", // NEW 28-11-2025
      missingFilterParameters: "filterparameters ontbreken", // NEW 28-11-2025
    } // NEW 28-11-2025
  },
  // #endregion

    // #region | Logbook pages
    logPages: {
      logbook: {
        problem: "Problem",
        warning: "Warning",
        info: "Info",
        debug: "Debug",
        system: "System",
        motor: "Motor",
        animal: "Animal",
        time: "time",
        level: "level",
        type: "type",
        message: "message",
        location: "location",
        controller: "controller",
        allControllers: "all controllers",
        controllerName: "controller name",
        deviceName: "device name",
        lanControllers: "lan controllers",
        getLog: "get log",
        noLogsAvailable: "no logs available",
        responder: "responder",
      },
    },
    // #endregion

  // #region | Global Settings pages
  globalSettingsPages: {
    globalSettings: {
      imperial: "Imperiaal",
      metric: "Metrisch",
      saveChanges: "wijzigingen opslaan",
      discardChanges: "wijzigingen negeren",
      userManagement: "gebruikersbeheer",
      timeZone: "tijdzone",
      feedDayStart: "begin voederdag",
      remove: "verwijderen"
    }
  },
  // #endregion

  // #region | Location Feeder Pages
  locationFeederPages: {
    locationFeeder: {
      sections: "secties",
      pens: "hokken",
      animals: "dieren",
      sectionNo: "Sectie nr.",
      pen: "Hok",
    },
    sections: {
      section: "sectie",
      sections: "secties",
      map: "kaart",
      animalAmount: "aantal dieren",
      penValueHeaders: "houd de muis op een waarde om het kolomtype te zien",
      sectionNotFound: "sectie niet gevonden",
      emptyPen: "Leeg hok",
      feeder: "voerunit",
      inThisPen: "in dit hok",
      activations: "activeringen",
      lastActivated: "laatste activatie",
      newSection: "nieuwe sectie",
      sectionName: "sectienaam",
      firstPenNo: "eerste hok nr.",
      penAmount: "aantal hokken",
      clickOnPen: "Klik op een hok om deze toe te voegen of weer te verwijderen.",
      penContent: "inhoud hok",
      feederOnly: "Alleen voerunit",
      water: "Water",
      activator: "Activator",
      feederOutput: "Voerunituitgang",
      waterOutput: "Wateruitgang",
      activatorInput: "Activator-ingang",
      since: "sinds",
      redirect: "Dit zal u doorsturen naar de dierenpagina.",
      expand: "uitvouwen",
      collapse: "inklappen",
      noSections: "Geen secties gevonden",
      noAnimal: "Geen dier" // NEW 21-11-2025
    },
    settings: {
      dailyRotation: "dagelijkse rotatie",
      dailyRotationDisclaimer: "NB: Als de locatie leeg is of het dier geen voercurve heeft toegewezen, zal de motor dagelijks draaien voor onderhoudsdoeleinden.",
      feedInSilos: "voer in silo's",
      attentionLimit: "meldingslimiet",
      feedAmount: "voerhoeveelheid", // NEW 11-11-2025
      defFeedAmount: "standaard voerhoeveelheid (g)" // NEW 11-11-2025
    }
  },
  // #endregion

  // #region | ESF Walk Through Pages
  esfWalkThroughPages: {
    esfWalkThrough: {
    },
    sections: {
      station: "station",
      feedMotor: "voermotor",
      feedSensor: "voersensor",
      gateMotor: "poortmotor",
      gateSensor: "poortsensor",
      inThisStation: "in dit station",
      previously: "voorheen",
      feedComponents: "voercomponenten",
      stationLastDays: "laatste 10 dagen",
      stationLog: "logboek"
    },
    settings: {
    }
  },
  // #endregion

  // #region | Focus View Pages
  focus_viewPages: {
    location: "locatie",
    system: "systeem",
    section: "sectie",
    inThisPen: "in dit hok",
    today: "vandaag",
    pen: "Hok",
    since: "sinds",
    day: "Dag",
    moveAnimal: "dier verplaatsen",
    newLocation: "nieuwe locatie",
    emptyPen: "Leeg hok",
  }
  // #endregion
}

export default Texts